import React, { ReactNode } from "react";
import {
	SvgLinkedin,
	SvgFacebook,
	SvgInstagram,
	SvgX
} from "../Icons/SocialIcons";
import { trackSocialClick } from "../../Analytics/googleAnalytics";

interface SocialProofProps {
	link: string;
}

// Domain to icon lookup table
const domainIconMap: Record<string, () => ReactNode> = {
	"linkedin.com": SvgLinkedin,
	"facebook.com": SvgFacebook,
	"instagram.com": SvgInstagram,
	"twitter.com": SvgX,
	"x.com": SvgX
};

// Domain to platform name lookup table (for analytics)
const domainNameMap: Record<string, string> = {
	"linkedin.com": "LinkedIn",
	"facebook.com": "Facebook",
	"instagram.com": "Instagram",
	"twitter.com": "X",
	"x.com": "X"
};

const SocialProof: React.FC<SocialProofProps> = ({ link }) => {
	// Extract domain from URL
	const getDomainFromUrl = (url: string): string => {
		try {
			const urlObj = new URL(url);
			const hostname = urlObj.hostname.toLowerCase();
			// Remove 'www.' prefix if present
			return hostname.replace(/^www\./, "");
		} catch (error) {
			console.error("Invalid URL:", url);
			return "";
		}
	};

	const domain = getDomainFromUrl(link);
	const IconComponent = domainIconMap[domain];
	const platformName = domainNameMap[domain];

	// If no matching icon is found, return null or a default icon
	if (!IconComponent) {
		return null;
	}

	const handleClick = () => {
		if (platformName) {
			trackSocialClick(platformName, link);
		}
	};

	return (
		<a
			href={link}
			target="_blank"
			rel="noopener noreferrer"
			className="inline-flex items-center justify-center transition-opacity hover:opacity-70 cursor-pointer"
			aria-label={`Visit our ${domain} page`}
			onClick={handleClick}
		>
			{IconComponent()}
		</a>
	);
};

export default SocialProof;
